import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Paper,
  Typography,
  useMediaQuery,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Avatar,
  Box,
} from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import { INVITE_COLUMNS_ENHANCED, INVITE_PROP } from "./constants";
import userActions from "./actions";
import TableActions from "./TableActions";
import useStyles from "./InvitesTableStyles";
import EnhancedTableHead from "components/common/EnhancedTableHead";
import { UserRole, UserRoleText } from "components/User/constants";
import moment from "moment";

const InvitesTable = () => {
  const classes = useStyles();
  const { setEditInvite, loadInvites, setOrderBy, setPagination } =
    userActions();
  const { invites, table, total } = useSelector((state) => state.invites);
  const { role } = useSelector((state) => state.auth);

  useEffect(() => {
    loadInvites();
  }, [loadInvites, table]);

  const handleRequestSort = (event, property) => {
    const isAsc = table.orderBy.order === "asc";
    setOrderBy({ col: property, order: isAsc ? "desc" : "asc" });
  };

  const handleChangePage = (event, newPage) => {
    setPagination({
      limit: table.limit,
      offset: newPage * table.limit,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination({ limit: parseInt(event.target.value), offset: 0 });
  };

  const headCells = [...INVITE_COLUMNS_ENHANCED];

  if (role === UserRole.SUPERADMIN) {
    headCells.push({
      id: "actions",
      label: "Actions",
      numeric: true,
      disablePadding: false,
      disableSort: true,
    });
  }
  const rowsPerPage = table.limit;
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  const emptyRows = rowsPerPage - invites.length;
  return (
    <Paper className={classes.paper}>
      {matches ? (
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              columns={headCells}
              classes={classes}
              order={table.orderBy.order}
              orderBy={table.orderBy.col}
              onRequestSort={handleRequestSort}
              rowCount={total}
            />
            <TableBody>
              {invites.map((row) => {
                return (
                  <TableRow
                    onClick={() =>
                      setEditInvite({
                        ...row,
                      })
                    }
                    tabIndex={-1}
                    key={row.id}
                  >
                    <TableCell scope="row">
                      <Typography>{row[INVITE_PROP.EMAIL]}</Typography>
                    </TableCell>
                    <TableCell>{UserRoleText[row[INVITE_PROP.ROLE]]}</TableCell>
                    <TableCell>{row[INVITE_PROP.STATUS]}</TableCell>
                    <TableCell>
                      {moment(row[INVITE_PROP.SENT_DATE]).format(
                        "MMM, DD YYYY"
                      )}
                    </TableCell>
                    <TableCell>
                      {moment(row[INVITE_PROP.EXPIRY_DATE]).format(
                        "MMM, DD YYYY"
                      )}
                    </TableCell>
                    {role === UserRole.SUPERADMIN && (
                      <TableCell align="right">
                        <TableActions />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 48 * emptyRows,
                  }}
                >
                  <TableCell />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <List>
          {invites.map((row) => {
            return (
              <ListItem key={row}>
                <ListItemAvatar>
                  <Avatar className={classes.AvatarSmall}>
                    <EmailIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={row[INVITE_PROP.EMAIL]}
                  secondary={
                    UserRoleText[row[INVITE_PROP.ROLE]] +
                    " • " +
                    row[INVITE_PROP.STATUS] +
                    " • " +
                    moment(row[INVITE_PROP.EXPIRY_DATE]).format("MMM, DD YYYY")
                  }
                />
                {role === UserRole.SUPERADMIN && (
                  <ListItemSecondaryAction>
                    <Box
                      edge="end"
                      onClick={() =>
                        setEditInvite({
                          ...row,
                        })
                      }
                    >
                      <TableActions />
                    </Box>
                  </ListItemSecondaryAction>
                )}
              </ListItem>
            );
          })}
        </List>
      )}
      <TablePagination
        rowsPerPageOptions={matches ? [10, 20, 30] : [10]}
        component="div"
        count={total}
        rowsPerPage={table.limit}
        page={table.offset / table.limit}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default InvitesTable;
